import React from 'react'
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";
import { contact } from "../../assets";
import { useTypewriter, Cursor } from "react-simple-typewriter";
const ContactLeft = () => {
    const [text] = useTypewriter({
        words: [
          "Graphic Designer.",
          "Network Engineer + Cyber Security Specialist.",
          "Flutter Developer.",
          "Full Stack Web Developer.",
          "Data Analyst.",
        ],
        loop: true,
        typeSpeed: 20,
        deleteSpeed: 10,
        delaySpeed: 2000,
      });
  return (
    <div
            className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 
          rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center"
          >
            <img
              className="w-full h-64 object-cover rounded-lg mt-2"
              src={contact}
              alt="contactMe"
            />
            <div className="flex flex-col gap-4">
              <h3 className="text-3xl font-bold text-white">Maxon Gomeka</h3>

              <p className="text-lg font-normal text-gray-400">
                a <span>{text}</span>
                <Cursor
                  cursorBlinking="false"
                  cursorStyle=" "
                  cursorColor="#ff014f"
                />
              </p>
              <p className="text-base text-gray-400 tracking-wide">
                Let's keep on learning new skills every day. You want to work as
                a team? Send me a DM.
              </p>
              <p className="text-base text-gray-400 items-center gap-2">
                Phone:{" "}
                <span className="text-sm text-lightText">
                  +265882791514
                </span>
              </p>
              <p className="text-base text-gray-400 items-center gap-2">
                Email: {""}
                <span className=" text-lightText">maxongomeka@gmail.com</span>
              </p>
            </div>
            <div>
              <h2 className="text-base uppercase font-titleFont mb-4">
                Find me on
              </h2>
              <div className=" flex gap-4">
                <span className="bannerIcon">
                  <a href="https://m.facebook.com/people/Macheda-Graphics/100083311030390/">
                    <FaFacebook />
                  </a>
                </span>
                <span className="bannerIcon">
                  <FaInstagram />
                </span>
                <span className="bannerIcon">
                  <FaTwitter />
                </span>
                <span className="bannerIcon">
                  <FaLinkedin />
                </span>
              </div>
            </div>
          </div>
  )
}

export default ContactLeft